import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["closeable", "inline", "multiline", "hollow", "StatusDot", "use", "children", "color"];
import styled, { useTheme } from 'foundations-theming/utils';
import { Tag } from '../Tag/Tag';
import { StatusDot } from '../StatusDot/StatusDot';
import { StatusTagProvider } from './StatusTagProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledStatusTagText = styled.span.withConfig({
  displayName: "StatusTag__StyledStatusTagText",
  componentId: "sc-171rc74-0"
})(() => {
  return {
    lineHeight: '22px'
  };
});
export const StatusTag = _ref => {
  let {
      closeable = false,
      inline = false,
      multiline = false,
      hollow = false,
      StatusDot: StatusDotComponent = StatusDot,
      use = 'info',
      children,
      color
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(StatusTagProvider, {
    tagStyleOverrides: {
      fontFamily: theme.typography['body-100'].fontFamily,
      fontWeight: theme.typography['body-100'].fontWeight,
      backgroundColor: 'transparent',
      borderBlockColor: 'transparent',
      borderInlineColor: 'transparent',
      color: theme.color['text-core-subtle'],
      lineHeight: 'normal',
      paddingInlineStart: theme.space['0'],
      verticalAlign: 'middle'
    },
    tagFlexWrapperStyleOverrides: {
      /* Prevent "height bleed" */
      marginTop: `-${theme.space[100]}`,
      marginBottom: `-${theme.space[100]}`
    },
    children: /*#__PURE__*/_jsx(Tag, Object.assign({
      use: use,
      closeable: closeable,
      inline: inline,
      multiline: children === undefined || multiline
    }, rest, {
      children: /*#__PURE__*/_jsxs(StyledStatusTagText, {
        children: [/*#__PURE__*/_jsx(StatusDotComponent, {
          color: color,
          hollow: hollow,
          use: use
        }), children]
      })
    }))
  });
};